module.exports = __webpack_public_path__ + "static/media/DKTN.0d636e8d.svg";